/**
 * @file CampaignCard config
 * @author caiguoqing
 */

export enum CampaignStatusEnum {
  // 进行中
  ACTIVE = 'Active',
  // 草稿
  DRAFT = 'Draft',
  // 结束
  ENDED = 'Ended',
  // 扣款失败 暂停
  PAUSED = 'Paused',
  // 取消
  CANCELLED = 'Cancelled',
  // 预测中
  PREDICTING = 'Predicting',
  // 预览中
  UNDER_REVIEW = 'Under_review',
  // 暂停  前端显示：Paused， 后端返回的实际状态是Temp paused
  TEMP_PAUSED = 'Temp_paused',
}

export const getCampaignStatusMap = (t: (key: string, opts?: any) => string): any => ({
  [CampaignStatusEnum.ACTIVE]: {
    tag: 'Premium',
    status: t('campaignDetail.status.active'),
    buttonText: 'Details',
    tagColor: '#c4330a',
    tagBgColor: '#ffead5',
    statusBgColor: '#dcfce7',
    statusDotColor: '#15803d',
    statusColor: '#14532d'
  },
  [CampaignStatusEnum.DRAFT]: {
    tag: 'STARTER',
    status: t('campaignDetail.status.draft', { defaultValue: 'Draft' }),
    buttonText: 'Edit and release',
    tagColor: '#171717',
    tagBgColor: '#F0F0F3',
    statusBgColor: '#FEF9C3',
    statusDotColor: '#CA8A04',
    statusColor: '#854D0E'
  },
  [CampaignStatusEnum.ENDED]: {
    tag: 'PrO',
    status: t('campaignDetail.status.ended', { defaultValue: 'Ended' }),
    buttonText: 'Details',
    tagColor: '#1e3a8a',
    tagBgColor: '#dbeafe',
    statusBgColor: '#F0F0F3',
    statusDotColor: '#404040',
    statusColor: '#171717'
  },
  [CampaignStatusEnum.PAUSED]: {
    tag: 'PrO',
    status: t('campaignDetail.status.paused'),
    buttonText: 'Details',
    tagColor: '#1e3a8a',
    tagBgColor: '#dbeafe',
    statusBgColor: '#FEF2F2',
    statusDotColor: '#EF4444',
    statusColor: '#EF4444'
  },
  [CampaignStatusEnum.CANCELLED]: {
    tag: 'PrO',
    status: t('campaignDetail.status.cancelled', { defaultValue: 'Cancelled' }),
    buttonText: 'Details',
    tagColor: '#1e3a8a',
    tagBgColor: '#dbeafe',
    statusBgColor: '#F3F4F6',
    statusDotColor: '#404040',
    statusColor: '#404040'
  },
  [CampaignStatusEnum.PREDICTING]: {
    tag: 'PrO',
    status: t('campaignDetail.status.predicting', { defaultValue: 'Predicting' }),
    buttonText: 'Edit and launch',
    tagColor: '#1e3a8a',
    tagBgColor: '#ffead5',
    statusBgColor: '#ffead5',
    statusDotColor: '#c4330a',
    statusColor: '#c4330a'
  },
  [CampaignStatusEnum.UNDER_REVIEW]: {
    tag: 'PrO',
    status: t('campaignDetail.status.reviewing', { defaultValue: 'Under review' }),
    buttonText: 'Details',
    tagColor: '#c4330a',
    tagBgColor: '#ffead5',
    statusBgColor: '#ffead5',
    statusDotColor: '#c4330a',
    statusColor: '#c4330a'
  },
  [CampaignStatusEnum.TEMP_PAUSED]: {
    tag: 'PrO',
    status: t('campaignDetail.status.paused', { defaultValue: 'Paused' }),
    buttonText: 'Temp paused',
    tagColor: '#171717',
    tagBgColor: '#ffead5',
    statusBgColor: '#F0F0F3',
    statusDotColor: '#171717',
    statusColor: '#171717'
  },
});
